// requireAdmin.js
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from '../../userContext';

const RequireAdmin = () => {
    const { user } = useContext(UserContext);

    if (!user || user.usertype !== 'admin') {
        return <Navigate to="/login" replace />;
    }
    return <Outlet />;
};

export default RequireAdmin;

